import { DEFAULT_METRICS_SETTINGS } from "src/components";
import { IMetricsSettings, useSettings } from "src/hooks";

const useUserMetricsSettings = (userGuid: string) => {
  const {
    userMetricsSettings: { [userGuid]: unsafeSettings },
    updateUserMetricsSettings,
  } = useSettings();

  const safeSettings: IMetricsSettings = {
    ...DEFAULT_METRICS_SETTINGS,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IMetricsSettings>) => {
      updateUserMetricsSettings(userGuid, updatedSettings);
    },
  };
};

export { useUserMetricsSettings };
